import React from 'react';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import moment from 'moment';
import Dialog from '@material-ui/core/Dialog';
import Button from 'components/button';
import Format from 'core/format';
import { i18n } from 'core/i18n';
import './datePicker.css';

export default class DatePicker extends React.Component {
	constructor(props) {
		super(props);
		this.handleSingleDayClick = this.handleSingleDayClick.bind(this);
		this.handleDayClick = this.handleDayClick.bind(this);
		this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
		this.handleResetClick = this.handleResetClick.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.clearDate = this.clearDate.bind(this);
		this.setDate = this.setDate.bind(this);
		this.renderDay = this.renderDay.bind(this);
		this.state = this.getInitialState();
	}
	getInitialState() {
		return {
			from: this.props.defaultFrom || null,
			to: this.props.defaultTo || null,
			enteredTo: this.props.defaultTo || null, // Keep track of the last day for mouseEnter.
			selectedDay: this.props.defaultDate || null,
			open: false,
		};
	}
	isSelectingFirstDay(from, to, day) {
		const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from);
		const isRangeSelected = from && to;
		return !from || isBeforeFirstDay || isRangeSelected;
	}
	// isSelectingFirstDay(from, to, day) {
	// 	const isbeforeSelectFirstDay = from && DateUtils.isDaybeforeSelect(day, from);
	// 	const isRangeSelected = from && to;
	// 	return !from || isbeforeSelectFirstDay || isRangeSelected;
	// }
	handleSingleDayClick(day, { selected }) {
		const self = this,
			{
				props
			} = self,
			{
				datePickerFareDisable = [],
				beforeSelect,
				selectedEvent = () => { }
			} = props;
		let disabled = false;
		datePickerFareDisable.map((item) => {
			if (Format.dateTime(item, 'yyyy-MM-dd') === Format.dateTime(day, 'yyyy-MM-dd')) {
				disabled = true;
			}
			return true;
		});
		if (day < beforeSelect) {
			disabled = true;
		}
		if (disabled) {
			return;
		}
		this.setState({
			selectedDay: selected ? undefined : day,
		});
		this.handleClose();
		selectedEvent(day, selected);
	}
	handleDayClick(day) {
		const self = this,
			{
				props,
				state
			} = self,
			{
				datePickerFareDisable = []
			} = props,
			{
				from,
				to
			} = state;
		let disabled = false;
		datePickerFareDisable.map((item) => {
			if (Format.dateTime(item, 'yyyy-MM-dd') === Format.dateTime(day, 'yyyy-MM-dd')) {
				disabled = true;
			}
			return true;
		});
		if (disabled) {
			return;
		}
		if (from && to && day >= from && day <= to) {
			this.handleResetClick();
			return;
		}
		if (this.isSelectingFirstDay(from, to, day)) {
			this.setState({
				from: day,
				to: null,
				enteredTo: null,
			});
		} else {
			this.setState({
				to: day,
				enteredTo: day,
			});
			this.handleClose();
		}
	}
	handleDayMouseEnter(day) {
		const { from, to } = this.state;
		if (!this.isSelectingFirstDay(from, to, day)) {
			this.setState({
				enteredTo: day,
			});
		}
	}
	handleResetClick() {
		this.setState({
			from: null,
			to: null,
			enteredTo: null,
		});
	}
	handleOpen() {
		this.setState({
			open: true
		});
	}
	clearDate() {
		this.setState({
			selectedDay: undefined
		});
	}
	setDate(date) {
		this.setState({
			selectedDay: date
		});
	}
	renderDay(day) {
		const self = this,
			{
				props
			} = self,
			{
				datePickerFare = {},
				beforeSelect = moment().toDate()
			} = props;
		const date = day.getDate();
		const dateStyle = {
			width: '55px',
			height: '55px',
			fontSize: 12,
			lineHeight: '20px',
		};
		return (
			<div style={dateStyle}>
				<div>{date}</div>
				{
					Object.keys(datePickerFare).length !== 0 && datePickerFare[Format.dateTime(day, 'yyyy-MM-dd')] !== 0 && day >= beforeSelect && (
						<div style={{ color: '#767574' }}>
							<span style={{ fontSize: '12px' }}>
								{datePickerFare[Format.dateTime(day, 'yyyy-MM-dd')]}
							</span>
						</div>
					)
				}
			</div>
		);
	}
	handleClose() {
		const self = this,
			{
				state
			} = self,
			{
				open
			} = state;
		this.setState({
			open: !open
		});
	}
	getValue() {
		const { from, to, selectedDay } = this.state;
		return { from: from, to: to, selectedDay: selectedDay };
	}
	render() {
		const self = this,
			{
				props,
				state
			} = self,
			{
				type = 'multi', //single:單選, multi:多選
				frameStyle,
				errorStatus,
				datePickerFareDisable = [], //無票價的日期,
				placeholder = i18n('departure_date'),
				disabled = false,
				beforeSelect = moment().toDate()
			} = props,
			{
				open,
				from,
				to,
				enteredTo,
				selectedDay
			} = state;
		const modifiers = { start: from, end: enteredTo };
		const selectedDays = [from, { from, to: enteredTo }];
		const disabledDays = [{
			before: beforeSelect,
			after: moment().add(1, 'years').toDate()
		}];
		disabledDays.push(...datePickerFareDisable);
		return (
			<div style={frameStyle}>
				{
					type === 'single' ? (
						<Button
							size='large'
							onClick={this.handleClose}
							className={`date-picker-botton ${errorStatus ? 'date-picker-error-border' : ''}`}
							disabled={disabled}
						>
							<div style={{ width: '100%' }}>
								<img className='date-picker-icon-single' alt='' src={require('assets/images/ic-date.svg')} />
								<div className='date-picker-text-single'>
									<div>
										{placeholder}
									</div>
									<div>
										{
											selectedDay && selectedDay.toLocaleDateString()
										}
									</div>
								</div>
							</div>
						</Button>
					) : (
							<Button
								size='large'
								onClick={this.handleClose}
								className={`date-picker-botton ${errorStatus ? 'date-picker-error-border' : ''}`}
							>
								<div style={{ width: '50%', position: 'relative' }}>
									<img className='date-picker-icon' alt='' src={'/static/assets/images/ic-date.svg'}
									/>
									<div className='date-picker-text'>
										<div>
											{i18n('departure_date')}
										</div>
										<div>
											{
												from && from.toLocaleDateString()
											}
										</div>
									</div>
								</div>
								<div className='gray-line'></div>
								<div style={{ width: '50%', position: 'relative' }}>
									<img className='date-picker-icon' alt='' src={'/static/assets/images/ic-date.svg'} />
									<div className='date-picker-text'>
										<div>
											{i18n('return_date')}
										</div>
										<div>
											{
												to && to.toLocaleDateString()
											}
										</div>
									</div>
								</div>
							</Button>
						)
				}

				{
					type === 'single' ? (
						<Dialog
							className={'singleDatePickerDialog'}
							open={!!open}
							fullWidth={true}
							maxWidth={false}
							onClose={this.handleClose}
							TransitionProps={{ timeout: { enter: 500, exit: 300 } }}
						>
							<div>
								<div style={{ fontSize: '18px', padding: '10px', textAlign: 'center' }}>
									{placeholder}
								</div>
							</div>
							<DayPicker
								className="RangeDatePickerLarge"
								numberOfMonths={2}
								selectedDays={this.state.selectedDay}
								month={this.state.selectedDay ? moment(this.state.selectedDay).toDate() : moment().toDate()}
								disabledDays={disabledDays}
								onDayClick={this.handleSingleDayClick}
								renderDay={this.renderDay}
							/>
							<DayPicker
								className="RangeDatePickerSmall"
								numberOfMonths={1}
								month={this.state.selectedDay ? moment(this.state.selectedDay).toDate() : moment().toDate()}
								selectedDays={this.state.selectedDay}
								disabledDays={disabledDays}
								onDayClick={this.handleSingleDayClick}
								renderDay={this.renderDay}
							/>
						</Dialog>
					) : (
							<Dialog
								className={'multiDatePickerDialog'}
								open={!!open}
								fullWidth={true}
								maxWidth={false}
								onClose={this.handleClose}
							>
								<DayPicker
									className="RangeDatePickerLarge"
									numberOfMonths={2}
									fromMonth={from}
									selectedDays={selectedDays}
									disabledDays={disabledDays}
									modifiers={modifiers}
									onDayClick={this.handleDayClick}
									onDayMouseEnter={this.handleDayMouseEnter}
									renderDay={this.renderDay}
								/>
								<DayPicker
									className="RangeDatePickerSmall"
									numberOfMonths={1}
									fromMonth={from}
									selectedDays={selectedDays}
									disabledDays={disabledDays}
									modifiers={modifiers}
									onDayClick={this.handleDayClick}
									onDayMouseEnter={this.handleDayMouseEnter}
									renderDay={this.renderDay}
								/>
							</Dialog>
						)
				}
			</div>
		);
	}
}
